import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';

import _ from 'underscore';
import mixpanelConstants from '../../constants/mixpanel';

export const setDnrList = createAction('SET_DNR_LIST');
export const setblueloadDisplay = createAction('SET_BLUE_LOAD_DISPLAY');
export const setPageNumber = createAction('SET_PAGE_NUMBER');
export const setSearchString = createAction('SET_SEARCH_STRING');
export const setSort = createAction('SET_SORT');
export const setSortOrder = createAction('SET_SORT_ORDER');
export const setReasons = createAction('SET_REASON');
export const setNurseList = createAction('SET_NURSE_LIST');
export const setAutoSearchStr = createAction('SET_AUTO_SEARCH_STR');
export const setorganizations = createAction('SET_ORGANIZATIONS');
export const setOrgFilter = createAction('SET_ORG_FILTER');
export const setLocFilter = createAction('SET_LOC_FILTER');
export const setDeptFilter = createAction('SET_DEPT_FILTER');
export const setReasonValue = createAction('SET_REASON_VALUE');
export const setSelectedUserId = createAction('SET_SELECTED_USER_ID');
export const setAcceptedAppliedShifts = createAction('SET_ACCEPTED_APPLIED_SHIFTS');

const initialState = {
	acceptedAppliedShifts: {},
	autoSearchString: '',
	dept: '',
	dnrList: {},
	loaddisplay: 'none',
	loc: '',
	nurseList: [],
	org: '',
	organizations: [],
	page_no: 1,
	reasons: [],
	reasonValue: '',
	search_string: '',
	selected_user_id: '',
	sort: '',
	sortorder: ''
};

export default handleActions(
	{
		SET_ACCEPTED_APPLIED_SHIFTS: (state, action) => ({ ...state, acceptedAppliedShifts: action.payload }),
		SET_AUTO_SEARCH_STR: (state, action) => ({ ...state, autoSearchString: action.payload }),
		SET_BLUE_LOAD_DISPLAY: (state, action) => ({ ...state, loaddisplay: action.payload }),
		SET_DEPT_FILTER: (state, action) => ({ ...state, dept: action.payload }),
		SET_DNR_LIST: (state, action) => ({ ...state, dnrList: action.payload }),
		SET_LOC_FILTER: (state, action) => ({ ...state, loc: action.payload }),
		SET_NURSE_LIST: (state, action) => ({ ...state, nurseList: action.payload }),
		SET_ORG_FILTER: (state, action) => ({ ...state, org: action.payload }),
		SET_ORGANIZATIONS: (state, action) => ({ ...state, organizations: action.payload }),
		SET_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_REASON: (state, action) => ({ ...state, reasons: action.payload }),
		SET_REASON_VALUE: (state, action) => ({ ...state, reasonValue: action.payload }),
		SET_SEARCH_STRING: (state, action) => ({ ...state, search_string: action.payload }),
		SET_SELECTED_USER_ID: (state, action) => ({ ...state, selected_user_id: action.payload }),
		SET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_SORT_ORDER: (state, action) => ({ ...state, sortorder: action.payload })
	},
	initialState
);

export const initializeValues = () => {
	return function (dispatch) {
		dispatch(setPageNumber('1'));
		dispatch(setSearchString(''));
		dispatch(setSort(''));
		dispatch(setSortOrder(''));
	};
};

export const getDnrList = () => {
	return function (dispatch, getState) {
		const { page_no, sort, sortorder, search_string } = getState().dnr;
		dispatch(setblueloadDisplay('block'));
		Agent.getDnrList(page_no, sort, sortorder, search_string).then((response) => {
			if (response.ok) {
				if (response.data.userdnrs) {
					response.data.userdnrs.forEach((s, index) => {
						response.data.userdnrs[index]['showAll'] = false;
					});
				}
				dispatch(setDnrList(response.data));
			} else {
				dispatch(handleError(response));
			}
			dispatch(setblueloadDisplay('none'));
		});
	};
};

export const removeDnr = (dnr_id) => {
	return function (dispatch) {
		Agent.deleteDNR(dnr_id).then((response) => {
			if (response.ok) {
				dispatch(getDnrList());
				mixpanel.track(mixpanelConstants.DELETE_DNR, { dnrId: dnr_id });
			}
		});
	};
};

//Api call to get DNR reason list
export const getDNRReason = () => {
	return function (dispatch) {
		const type = 'dnr';
		Agent.getDNRReason(type).then((response) => {
			if (response.ok) {
				dispatch(setReasons(response.data));
			}
		});
	};
};

// Api call to get nurse email and name list
export const autoSearchNurse = () => {
	return function (dispatch) {
		Agent.autoSearchNurse('').then((response) => {
			if (response.ok) {
				dispatch(setNurseList(response.data));
			}
		});
	};
};

// Get organization list
export const organization = () => {
	return function (dispatch) {
		Agent.organization().then((response) => {
			if (response.ok) {
				response.data.sort(function (a, b) {
					if (a.title.toLowerCase() < b.title.toLowerCase()) return -1;
					if (a.title.toLowerCase() > b.title.toLowerCase()) return 1;
					return 0;
				});
				dispatch(setorganizations(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const createDnr = (deptIds, callback) => {
	return function (dispatch, getState) {
		const dnr = getState().dnr;
		const { org, loc, reasonValue, selected_user_id } = dnr;
		let loggedUserId = getState().user.id;

		dispatch(setblueloadDisplay('block'));
		Agent.createDnr(selected_user_id, parseInt(org), parseInt(loc), deptIds, reasonValue).then((response) => {
			dispatch(setblueloadDisplay('none'));
			if (response.ok) {
				dispatch(getDnrList());
				trackAddNewDnr(getTrackingData(dnr, deptIds), loggedUserId);
				callback();
			} else {
				if (response.status == 400) {
					alert('This nurse has been already added to DNR.');
				}
			}
		});
	};
};

const getTrackingData = (dnr, deptIds) => {
	const { org, loc, reasonValue, selected_user_id, organizations, dnrList } = dnr;
	let filteredOrg = [];
	let locations = [];
	let location_options = [];
	let departments = [];
	let organization_name = '';
	let location_name = '';
	let department_names = [];
	let trackingData = {};
	let nurseEmail = '';

	let nurseDnr = dnrList && dnrList.userdnrs && dnrList.userdnrs.find((dnr) => dnr.user_id == selected_user_id);
	nurseEmail = nurseDnr && nurseDnr.username;

	filteredOrg = _.where(organizations, { organization_id: parseInt(org) });

	if (filteredOrg[0] && filteredOrg[0]['locations'] != undefined) {
		locations = filteredOrg[0]['locations'];
	}
	organization_name = filteredOrg[0] && filteredOrg[0].organization_name;
	location_options = _.where(locations, { location_id: parseInt(loc) });
	location_name = location_options[0] && location_options[0].location_name;

	if (location_options[0] && location_options[0]['departments'] != undefined) {
		departments = location_options[0]['departments'];
	}
	department_names = deptIds.map((id) => departments.find((department) => department.department_id == id).dept_name);

	trackingData = {
		departments: department_names,
		dnrReason: reasonValue,
		location: location_name,
		nurseEmail: nurseEmail,
		nurseId: selected_user_id,
		organization: organization_name
	};

	return trackingData;
};

const trackAddNewDnr = (trackingData, loggedUserId) => {
	mixpanel.track(mixpanelConstants.ADD_NEW_DNR, trackingData);

	// Switching current user to nurse and adding same event for nurse as well so that they can be sent email easily
	mixpanel.identify(trackingData.nurseId);
	mixpanel.track(mixpanelConstants.ADD_DNR_FOR_NURSE, trackingData);

	// Switching back to admin as current user
	mixpanel.identify(loggedUserId);
};

export const getAcceptedNApplied = (deptIds) => {
	return function (dispatch, getState) {
		const { selected_user_id } = getState().dnr;
		let deptValues = deptIds.join();

		Agent.getAcceptedNApplied(selected_user_id, deptValues).then((response) => {
			if (response.ok) {
				dispatch(setAcceptedAppliedShifts(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};
